import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import { Period } from '../types/period';
import { SOFTLINE_API_BONUSABFRAGE_PERIODEN } from '../bonusabfrage.api';

@Injectable()
export class PeriodRepository extends ReadonlyHttpApiListRepository<
  Result<Period[]>,
  null
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_BONUSABFRAGE_PERIODEN);
  }

  override getLoadPathParams(params: null): Dictionary<unknown> {
    return {};
  }
}
